import axios from "axios";
import { useAuth } from "@clerk/react";
import { useMemo, useRef } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useApi() {
  const { getToken } = useAuth();
  const tokenRef = useRef(getToken);
  tokenRef.current = getToken;
  return useMemo(() => {
    const inst = axios.create({ baseURL: `${BACKEND_URL}/api` });
    inst.interceptors.request.use(async (cfg) => {
      const t = await tokenRef.current();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, []);
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join(", ");
  return d || e?.message || "Something went wrong";
}

export async function downloadBlob(api, path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function downloadQuote(api, trip, option) {
  const optionId = option?.id;
  const res = await api.get(`/trips/${trip.id}/quote.pdf`, {
    responseType: "blob",
    params: optionId ? { option_id: optionId } : {},
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `JetSet-Quote-${trip.ref.replace(/[^A-Za-z0-9]+/g, "-")}${option ? `-option-${option.rank}` : ""}.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
